module.exports = __webpack_public_path__ + "static/media/ellipsis-purple.b267d8d0.gif";